<template>
  <b-modal
    id="modalDateTimeConfig"
    v-model="localIsActive"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    size="md"
    header-bg-variant="primary"
    @show=""
    @hidden="closeModal()"
  >
    <template #modal-title>
      <span class="text-white">Cambiar contraseña de administrador - {{ hanwhaDvr.name }}</span>
    </template>

    <div v-if="loadingSearchUsers" class="tab-content-loading d-flex justify-content-center align-items-center">
      <b-spinner label="Loading" variant="primary" />
    </div>
    <template v-else>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="user_id"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              label="Id de usuario"
              label-for="user_id"
            >
              <b-form-input
                id="user_id"
                v-model="itemData.user_id"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="current_password"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              label="Contraseña actual"
              label-for="current_password"
            >
              <b-form-input
                id="current_password"
                v-model="itemData.current_password"
                :state="getValidationState(validationContext)"
                trim
                :type="passwordFieldsTypes.current_password.type"
              />
              <b-input-group-append>
                <button type="button" class="btn"  @click="togglePasswordVisibility('current_password')">
                  <feather-icon
                    class="cursor-pointer"
                    color="#000"
                    :icon="passwordFieldsTypes.current_password.icon"
                  />
                </button>
              </b-input-group-append>
            </b-form-group>
            <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
          </validation-provider>

          <div class="text-right">
            <b-button
              type="submit"
              variant="primary"
              :disabled="loading"
            >
              Guardar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { required } from '@validations';
import moment from 'moment-timezone';
import popperHelper from "@/libs/popper-helper";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import vSelect from "vue-select";
import formValidation from '@core/comp-functions/forms/form-validation';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import DateTime from './date-time-language/DateTime.vue'
import Dst from './date-time-language/Dst.vue'
import Holidays from './date-time-language/Holidays.vue';
import TimezoneLanguage from './date-time-language/TimezoneLanguage.vue';

export default {
  components: {
    DateTime,
    Dst,
    Holidays,
    TimezoneLanguage,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    hanwhaDvr: {
      type: Object,
      require: true
    },
    isModalUpdatePasswordAdminActive: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      required
    }
  },
  setup(props, { emit }) {
    const resetData = () => {
      itemData.value = {
        user_id: null,
        current_password: null,
        new_password: null,
        password_confirm: null
      }
    }

    //COMPOSABLES
    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    //DATA
    const loading = ref(false);

    const loadingSearchUsers = ref(false);

    const itemData = ref({
      user_id: null,
      current_password: null,
      new_password: null,
      password_confirm: null
    });

    const passwordFieldsTypes = ref({
      current_password: {
        type: 'password',
        icon: 'EyeIcon'
      },
      new_password: {
        type: 'password',
        icon: 'EyeIcon'
      },
      password_confirm: {
        type: 'password',
        icon: 'EyeIcon'
      }
    });

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.isModalUpdatePasswordAdminActive;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    //METHODS
    const closeModal = () => {
      resetData();
      emit('close-modal');
    }

    const onSubmit = async () => {
      const request = {

      }


      loading.value = true;

      await axios.post('/v1/hanwha/dvr/admin/set-date-time-language', request)
        .then(async (response) => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });


        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error al guardar la información',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const passwordToggleIcon = (field) => {
      const typeByCurrentType = {
        password: 'IconEye',
        text: 'EyeOffIcon'
      }

      passwordFieldsTypes.value[field].icon = typeByCurrentType[passwordFieldsTypes.value[field].type]
    }

    const togglePasswordVisibility = (field) => {
      const typeByCurrentType = {
        password: 'text',
        text: 'password'
      }
      const iconByCurrentType = {
        password: 'EyeIcon',
        text: 'EyeOffIcon'
      }

      passwordFieldsTypes.value[field].type = typeByCurrentType[passwordFieldsTypes.value[field].type];
      passwordFieldsTypes.value[field].icon = iconByCurrentType[passwordFieldsTypes.value[field].type];

    }

    return {
      getValidationState,
      resetForm,
      refFormObserver,

      itemData,
      loading,
      loadingSearchUsers,
      passwordFieldsTypes,

      localIsActive,

      closeModal,
      onSubmit,
      passwordToggleIcon,
      togglePasswordVisibility
    }
  }
}
</script>

<style scoped></style>
